import { install } from 'resize-observer'

if (typeof window !== 'undefined') {
	install()
}

install()
